export default __webpack_public_path__ + "static/media/logo.74846b6d.png";